import React, { Component } from 'react';
import { Field } from 'redux-form';
import SelectField from './SelectField';

class CustomDateSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { initDates: [] };
    }

    componentWillMount() {
        this.state.initDates = [
            {
              "id": 0,
              "name": "Menos de 6 meses"
            },
            {
              "id": 6,
              "name": "Entre 6 meses - 1 año"
            },
            {
              "id": 12,
              "name": "1 año - 1 año y medio"
            },
            {
              "id": 18,
              "name": "1 año y medio - 2 años"
            },
            {
              "id": 24,
              "name": "2 años - 2 años y medio"
            },
            {
              "id": 30,
              "name": "2 años y medio - 3 años"
            },
            {
              "id": 36,
              "name": "3 años - 3 años y medio"
            },
            {
              "id": 42,
              "name": "3 años y medio - 4 años"
            },
            {
              "id": 48,
              "name": "Más de 4 años"
            }
        ];
    }

    render() {
        return (
            <Field
                className="form-control"
                name="init_date"
                component={SelectField}
                options={this.state.initDates}
                defaultValue={'Antigüedad laboral:'}
                label={'Antigüedad'}
                type={this.props.type}
            />
        );
    }
}

export default CustomDateSelect;


/** WEBPACK FOOTER **
 ** ./src/components/CustomDateSelect.js
 **/